import { render } from "./editdiscussion.vue?vue&type=template&id=40105490&scoped=true"
import script from "./editdiscussion.vue?vue&type=script&lang=js"
export * from "./editdiscussion.vue?vue&type=script&lang=js"

import "./editdiscussion.vue?vue&type=style&index=0&id=40105490&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40105490"]])

export default __exports__